import { render, staticRenderFns } from "./NormalSearchNav506.vue?vue&type=template&id=f0ba4fd0&scoped=true&"
import script from "./NormalSearchNav506.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav506.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ba4fd0",
  null
  
)

export default component.exports